import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {UserService} from '../../../services/user/user.service';
import {Store} from '@ngrx/store';
import {ProposalUser} from '../../../model/proposal/proposalUser';
import {selectUser} from '../../../store/user/selectors/user.selectors';
import {User} from '../../../model/user';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-small-device-dialog',
    templateUrl: './small-device-dialog.component.html',
    styleUrls: ['./small-device-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SmallDeviceDialogComponent implements OnInit {

  disableDialog: boolean = false;
  activeUserId: string = null;
  title: string = '';
  content: string = '';

  constructor(public dialogRef: MatDialogRef<SmallDeviceDialogComponent>,
              public userService: UserService,
              private readonly userStore: Store<ProposalUser>,
              @Inject(MAT_DIALOG_DATA) data) {
    this.title = data.title;
    this.content = data.content;
  }

  ngOnInit(): void {
    this.userStore.select(selectUser).subscribe(user => {
      if (!user.showSmallDeviceDialog) {
        this.dialogRef.close();
      }
      this.activeUserId = user.id;
    });
  }

  toggleSmallDeviceDialog() {
    if (this.disableDialog) {
      let user = new User();
      user.showSmallDeviceDialog = !this.disableDialog;
      this.userService.updateUser(this.activeUserId, user)?.subscribe();
    }
    this.dialogRef.close();
  }


}
